const FromReturnEditor = [{
	key: 'ExpressCode',
	title: "单号：",
	inputtype: "input",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "text",
	placeholder: "请输入",
	width: 198,
	height: 32,
	disabled: false,
	marginLeft: 74,
	marginTop: 20,
	displayVal: "inline-block",
	fontWeightVal: 500
}, {
	key: 'BackFillRemark',
	title: "备注：",
	inputtype: "input",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "text",
	placeholder: "请输入",
	width: 200,
	height: 32,
	disabled: false,
	marginLeft: 74,
	marginTop: 20,
	displayVal: "inline-block",
	fontWeightVal: 500
}];
export default FromReturnEditor;